<template>
  <div class="pay-detail-section pay-detail-grid pay-detail-grid--virement">
    <a-divider class="detail-divider">
      <a-icon type="bank" /> {{ $t("decaissement.paymentMethod.virement") }}
    </a-divider>
    <div class="detail-columns-header">
      <div class="column-header idx-col">#</div>
      <div class="column-header">{{ $t("decaissement.virementNum") }}</div>
      <div class="column-header">{{ $t("decaissement.chequeTitulaire") }}</div>
      <div class="column-header">{{ $t("recette.montant") }}</div>
      <div class="column-header actions-col"></div>
    </div>
    <div class="detail-items">
      <div
        v-for="(item, index) in rows"
        :key="index"
        class="detail-row"
        :class="{ 'detail-row--alt': index % 2 === 0 }"
      >
        <div class="detail-cell idx-col"><span class="row-num">{{ index + 1 }}</span></div>
        <div class="detail-cell">
          <a-input
            :value="item.num"
            size="small"
            :placeholder="$t('decaissement.placeholderVirementRef')"
            :class="{ 'input-error': isInvalid(index, 'num') }"
            @change="e => onUpdate(index, 'num', e.target.value)"
          />
        </div>
        <div class="detail-cell">
          <a-input
            :value="item.titulaire"
            size="small"
            :placeholder="$t('decaissement.placeholderTitulaire')"
            :class="{ 'input-error': isInvalid(index, 'titulaire') }"
            @change="e => onUpdate(index, 'titulaire', e.target.value)"
          />
        </div>
        <div class="detail-cell">
          <a-input-number
            :value="item.montant"
            size="small"
            style="width: 100%"
            :min="0"
            :precision="3"
            :placeholder="$t('decaissement.placeholderAmount')"
            :class="{ 'input-error': isInvalid(index, 'montant') }"
            @change="v => onUpdate(index, 'montant', v)"
          />
        </div>
        <div class="detail-cell actions-col">
          <a-button v-if="index > 0" type="danger" icon="delete" size="small" @click="onRemove(index)" />
        </div>
      </div>
    </div>
    <a-button type="dashed" block icon="plus" class="mt-2" @click="onAdd">
      {{ $t("decaissement.addVirement") }}
    </a-button>
    <div class="sum-bar mt-2" :class="{ match: sumMatch, mismatch: !sumMatch }">
      <span>{{ $t("recette.montant") }}: {{ sum.toFixed(3) }} / {{ totalRequired.toFixed(3) }}</span>
      <a-tag :color="sumMatch ? 'green' : 'red'">{{ sumMatch ? "OK" : $t("dette.sumMismatch") }}</a-tag>
    </div>
  </div>
</template>

<script>
const EMPTY = { num: null, titulaire: null, montant: 0 };

export default {
  name: "PayVirementSection",
  props: {
    rows: { type: Array, required: true },
    totalRequired: { type: Number, default: 0 },
  },
  data() {
    return { errors: [] };
  },
  computed: {
    sum() { return this.rows.reduce((s, r) => s + (Number(r.montant) || 0), 0); },
    sumMatch() { return Math.abs(this.sum - this.totalRequired) < 0.01; },
  },
  methods: {
    onUpdate(i, f, v) {
      this.$emit("update", i, f, v);
      this.validate(i);
    },
    onAdd() {
      if (this.rows.length && !this.validate(this.rows.length - 1)) return;
      this.$emit("add", { ...EMPTY });
    },
    onRemove(i) {
      this.$emit("remove", i);
      this.errors.splice(i, 1);
    },
    validate(i) {
      const r = this.rows[i];
      if (!r) return true;
      const e = {};
      if (!r.num) e.num = true;
      if (!r.titulaire) e.titulaire = true;
      if (!r.montant || r.montant <= 0) e.montant = true;
      this.$set(this.errors, i, e);
      return Object.keys(e).length === 0;
    },
    validateAll() {
      let ok = true;
      this.rows.forEach((_, i) => { if (!this.validate(i)) ok = false; });
      return ok && this.sumMatch;
    },
    isInvalid(i, f) { return this.errors[i] && this.errors[i][f]; },
  },
};
</script>

<style scoped>
@import "./payDetailSection.css";
</style>
